<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "bc-menu-slot",
  render() {
    return this.$slots.default;
  },
};
</script>